import { Button, Stack, Text } from '@chakra-ui/react'

import useAPIWrapper from '@/client/hooks/useAPIWrapper'
import RPC from '@/client/rpc'

import { useToaster } from '@/components/Toast/useToaster'
import ModalV3 from '@/components/UI/Modal/ModalV3'

export default function DeletePostModal({
  postId,
  open,
  onClose,
}: {
  postId: number
  open: boolean
  onClose: () => void
}): JSX.Element {
  const toast = useToaster()
  const [handleDelete, isDeleting] = useAPIWrapper(
    async () => {
      onClose()
      await RPC.deletePost({
        postId,
      })
      toast({
        title: 'This post has been deleted.',
        status: 'success',
      })
    },
    [postId, toast, onClose],
    'Delete Post'
  )

  return (
    <ModalV3
      size="lg"
      open={open}
      onClose={onClose}
      title="Delete Post"
      body={() => <Text>Are you sure you&apos;d like to delete this post?</Text>}
      rightFooterContent={() => (
        <Stack direction="row" spacing="8px">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleDelete} isLoading={isDeleting} variant="danger">
            Delete
          </Button>
        </Stack>
      )}
    />
  )
}
